module.exports = __webpack_public_path__ + "img/11.3416b7d4.jpg";